import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableLoyaltyWallet',
  initialState: false,
  reducers: {
    setEnableLoyaltyWallet(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableLoyaltyWallet } = slice.actions;

export default slice.reducer;
